import { mapEnumToOptions } from '@abp/ng.core';

export enum EmailStatus {
  Draft = 0,
  Scheduled = 1,
  Failed = 2,
  Sent = 3,
}

export const emailStatusOptions = mapEnumToOptions(EmailStatus);
